import {EventEmitter, Input, Output} from '@angular/core';
import {ModalBasicComponent} from './modal-basic.component';

export class ModalInterface {
   @Input() data: any;
   @Input() modal: ModalBasicComponent;
   @Output() result = new EventEmitter<any>();
}
